import React from 'react';
import i18next from 'i18next';
import en from './i18n/en';
import jp from './i18n/jp';

i18next.addResourceBundle('en', 'userWithProjectSelectedPage', en);
i18next.addResourceBundle('jp', 'userWithProjectSelectedPage', jp);

const AnalyticsDashboardAppConfig = {
	settings: {
		layout: {
			config: {}
		}
	},
	routes: [
		{
			path: '/dashboard/map',
			component: ''
		}
	]
};

export default AnalyticsDashboardAppConfig;
